export default __webpack_public_path__ + "static/media/young, friendly, silly, clean.7aff54ca.jpg";